if (!customElements.get('back-to-top')) {
  customElements.define(
    'back-to-top',
    class BackToTop extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.back-to-top__button');
        this.threshold = 600;

        this.onScroll = this.onScroll.bind(this);
        this.onClick = this.onClick.bind(this);

        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.button.addEventListener('click', this.onClick);

        this.onScroll();
      }

      onScroll() {
        this.classList.toggle('back-to-top--visible', window.scrollY > this.threshold);
      }

      onClick() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
      }
    }
  );
}
